{
  "id": "campaign-058",
  "name": "Hidden Croft",
  "seed": "campaign:58",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........RRRR",
    "........RRRR",
    "zz......____",
    ".z..........",
    ".z....zzzzzz",
    ".zu.y.zy.u..",
    ".zccc.zccc..",
    ".zccc.zccc..",
    "..ffffffffff",
    "x...........",
    "..y.#....y..",
    "............",
    "ffffffff..ff",
    "............",
    "...y....y...",
    "....u..u....",
    "............",
    "......x....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 9,
      "y": 12
    },
    {
      "kind": "rabbit",
      "x": 4,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 6,
      "y": 11
    }
  ],
  "generatorVersion": 3,
  "level": 58,
  "biome": "farm",
  "par": {
    "reel": 5910,
    "push": 5538,
    "selfPropelled": 5136,
    "tractor": 5100,
    "zeroTurn": 3349,
    "fairway": 2926
  },
  "routeTries": {
    "par": {
      "reel": 5,
      "push": 15,
      "selfPropelled": 13,
      "tractor": 9,
      "zeroTurn": 20,
      "fairway": 0
    }
  }
}
